import { get, isEmpty, pick } from 'lodash';
import { useEffect } from 'react';
import { init, FullStory } from '@fullstory/browser';
import config from '../config';
import { useIdentity } from '../hooks';

const orgId = get(config, 'full_story.orgId');
if (orgId) {
  init({ orgId });
}

export const setIdentity = (identity) => {
  if (!isEmpty(identity)) {
    FullStory('setIdentity', {
      uid: identity.assumed_by || identity.login_email || '',
      properties: pick(identity, [
        'assumed_by', 'company_name', 'company_type', 'company_id', 'user_id',
        'user_first_name', 'user_last_name', 'login_email',
      ]),
    });
  }
};

const Analytics = ({ children }) => {
  const identity = useIdentity();
  useEffect(() => {
    setIdentity(identity);
  }, [identity]);

  return children;
};

export default Analytics;

